import React, { lazy } from "react";
import { Routes, Route } from "react-router";
import Login from "./pages/Login";
import ScrollToTop from "./components/ScrollToTop";
import AddManager from "./components/AddManager/AddManager";
import { useAppSelector } from "./app/hooks";
import ToastContainer from "./components/CustomComponents/Toaster/ToastContainer";

import Notification from "./pages/Notification";
import PageLayout from "./pages/PageLayout";
import NotFound from "./pages/NotFound";
import EmployeeLasttracked from "./components/Employees/EmployeeLasttracked/EmployeeLasttracked";
import MissedScreenshots from "./components/Screenshots/MissedScreenshots";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Screenshots = lazy(() => import("./pages/Screenshots"));
const Roles = lazy(() => import("./pages/roles"));
const ManagerList = lazy(() => import("./pages/ManagerList"));
const Settings = lazy(() => import("./pages/Settings"));
const Reports = lazy(() => import("./pages/Reports"));
const EmployeePerformance = lazy(
  () => import("./pages/EmployeePerformance")
);
const ExployeesLists = lazy(() => import("./pages/ExployeesLists"));
const EmployeeOverview = lazy(() => import("./pages/EmployeeOverview"));

function App() {
  const addManager = useAppSelector((state) => state.addManager);
  const syncState = useAppSelector((state) => state.settingSync);

  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<PageLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/screenshots" element={<Screenshots />} />

          <Route
            path="/missedscreenshots"
            element={<MissedScreenshots />}
          />

          <Route path="/roles" element={<Roles />} />

          <Route path="/managerList" element={<ManagerList />} />

          <Route path="/addroles" element={<Roles />} />

          <Route path="/editroles" element={<Roles />} />

          <Route path="/viewroles" element={<Roles />} />

          <Route path="/settings" element={<Settings />} />

          <Route path="/reports" element={<Reports />} />

          <Route
            path="/employeePerformance"
            element={<EmployeePerformance />}
          />

          <Route
            path="/employeelist"
            element={<ExployeesLists />}
          />

          <Route
            path="/employeeLasttracked"
            element={<EmployeeLasttracked />}
          />

          <Route path="/notification" element={<Notification />} />

          <Route
            path="/employeeOverview"
            element={<EmployeeOverview />}
          />

          {/* Catch-all 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      {addManager?.modalShow && <AddManager />}

      {syncState?.isSync && (
        <div className="loader-container">
          <img
            src="/images/loader/content_loader.gif"
            className="image-loader-container"
            alt="Loading"
          />
        </div>
      )}

      <ToastContainer />
    </>
  );
}

export default App;